import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { SettingFilters, SettingSlice } from "./settingsTypes.ts";

const initialState: SettingSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "id",
    order: "desc",
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<SettingSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<SettingSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof SettingFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<SettingSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  settingsSlice.actions;

export const selectPage = (state: RootState) => state.settings.page;
export const selectRowsPerPage = (state: RootState) =>
  state.settings.rowsPerPage;
export const selectFilter = (state: RootState) => state.settings.filter;
export const selectSort = (state: RootState) => state.settings.sort;

export default settingsSlice.reducer;
